import {
  POSTINGS_GET_REQUEST,
  POSTINGS_GET_SUCCESS,
  POSTINGS_GET_FAILURE,
  COPIES_POSTINGS_GET_REQUEST,
  COPIES_POSTINGS_GET_SUCCESS,
  COPIES_POSTINGS_GET_FAILURE,
  UPDATE_POSTINGS_AFTER_ASSIGN_REQUEST,
  UPDATE_POSTINGS_AFTER_ASSIGN_SUCCESS,
  UPDATE_POSTINGS_AFTER_ASSIGN_FAILURE,
  UPDATE_POSTINGS_AFTER_RESCHEDULE_REQUEST,
  UPDATE_POSTINGS_AFTER_RESCHEDULE_SUCCESS,
  UPDATE_POSTINGS_AFTER_RESCHEDULE_FAILURE,
  UPDATE_POSTINGS_AFTER_UNASSIGN_REQUEST,
  UPDATE_POSTINGS_AFTER_UNASSIGN_SUCCESS,
  UPDATE_POSTINGS_AFTER_UNASSIGN_FAILURE,
  POSTINGS_RESET_DATA,
} from '../../constants/types';
import {
  selectSelectedDate,
  selectSelectedTeam,
  selectSchedulerIsNightMode,
} from '../../../reducers/areas/dailyPlanning/selectors';
import { HTTP_METHOD } from '../../constants/methods';
import { queryStringBuilder } from '../../../utils/helpers';
import axios from '../../../utils/axios';

function setPostings(response, isNightMode, selectedDate, schedulerModeStartTime, schedulerModeEndTime) {
  return {
    type: POSTINGS_GET_SUCCESS,
    response,
    isNightMode,
    selectedDate,
    schedulerModeStartTime,
    schedulerModeEndTime,
  };
}

function resetPostings() {
  return {
    type: POSTINGS_RESET_DATA,
  };
}

function getPostingsUpdateDataAfterReschedule(oldAssignGuid, assignmentId, oldPostingId, newPostingId, date) {
  return {
    types: [
      UPDATE_POSTINGS_AFTER_RESCHEDULE_REQUEST,
      UPDATE_POSTINGS_AFTER_RESCHEDULE_SUCCESS,
      UPDATE_POSTINGS_AFTER_RESCHEDULE_FAILURE,
    ],
    shouldCallAPI: () => true,
    buildCallParameters: state => {
      const parameters = {
        assignmentId,
        oldAssignGuid,
        oldPostingId,
        newPostingId,
        date,
        selectedDate: selectSelectedDate(state),
        isNightMode: selectSchedulerIsNightMode(state),
        IsSchedulerDayNightMode: true,
      };
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetPostingsUpdateDataAfterReschedule${queryStringBuilder(parameters)}`,
      };
    },
  };
}
function setPostingsLoading(silent) {
  return {
    type: POSTINGS_GET_REQUEST,
    silent,
  };
}

function getPostings(forceUpdate, silent, isNightMode, selectedDate, schedulerModeStartTime, schedulerModeEndTime) {
  return {
    types: [POSTINGS_GET_REQUEST, POSTINGS_GET_SUCCESS, POSTINGS_GET_FAILURE],
    shouldCallAPI: forceUpdate ? () => true : () => true,
    buildCallParameters: state => {
      const parameters = {
        date: selectSelectedDate(state),
        teamIds: selectSelectedTeam(state),
        isNightMode,
        IsSchedulerDayNightMode: true,
      };
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetPostings${queryStringBuilder(parameters)}`,
      };
    },
    silent,
    isNightMode,
    selectedDate,
    schedulerModeStartTime,
    schedulerModeEndTime,
  };
}

function getCopiesPostings(assignmentId) {
  return {
    types: [COPIES_POSTINGS_GET_REQUEST, COPIES_POSTINGS_GET_SUCCESS, COPIES_POSTINGS_GET_FAILURE],
    shouldCallAPI: () => true,
    buildCallParameters: () => {
      const parameters = {
        assignmentId,
      };
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetCopiesPostingsForUpdate${queryStringBuilder(parameters)}`,
      };
    },
  };
}

const startAssignRequest = () => ({
  type: UPDATE_POSTINGS_AFTER_ASSIGN_REQUEST,
});

const errorAssingRequest = error => ({
  type: UPDATE_POSTINGS_AFTER_ASSIGN_FAILURE,
  error,
});

const successAssignRequest = response => ({
  type: UPDATE_POSTINGS_AFTER_ASSIGN_SUCCESS,
  response,
});

export const getPostingsUpdateDataAfterAssign = (
  assignmentId,
  oldAssignGuid,
  postingId,
  date,
  jwtToken,
  masterId,
) => async (dispatch, getState) => {
  const token = `Bearer ${jwtToken}`;
  const state = getState();
  dispatch(startAssignRequest());
  const parameters = {
    assignmentId,
    oldAssignGuid,
    postingId,
    date,
    masterTreatmentInstanceId: masterId,
    selectedDate: selectSelectedDate(state),
    isNightMode: selectSchedulerIsNightMode(state),
  };
  try {
    const response = await axios({
      url: `v1/query/GetPostingsUpdateDataAfterAssign${queryStringBuilder(parameters)}`,
      headers: {
        Authorization: token,
      },
    });
    dispatch(successAssignRequest(response));
  } catch (error) {
    dispatch(errorAssingRequest(error));
  }
};

function getPostingsUpdateDataAfterUnAssign(oldAssignGuid, assignmentId, postingId, date, teamId) {
  return {
    types: [
      UPDATE_POSTINGS_AFTER_UNASSIGN_REQUEST,
      UPDATE_POSTINGS_AFTER_UNASSIGN_SUCCESS,
      UPDATE_POSTINGS_AFTER_UNASSIGN_FAILURE,
    ],
    shouldCallAPI: () => true,
    buildCallParameters: state => {
      const parameters = {
        assignmentId,
        oldAssignGuid,
        postingId,
        date,
        teamId,
        selectedDate: selectSelectedDate(state),
        isNightMode: selectSchedulerIsNightMode(state),
      };
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetPostingsUpdateDataAfterUnAssign${queryStringBuilder(parameters)}`,
      };
    },
  };
}

export {
  getPostings,
  setPostings,
  setPostingsLoading,
  getCopiesPostings,
  getPostingsUpdateDataAfterReschedule,
  getPostingsUpdateDataAfterUnAssign,
  resetPostings,
};
